<template>
    <div class="wrapper">
        <emoji-picker @emoji="append" :search="search">
            <div
                class="svg-button"
                :class="{ 'button-reaction': emojiReaction }"
                slot="emoji-invoker"
                slot-scope="{ events: { click: clickEvent } }"
                @click.stop="clickEvent"
                @click="openEmoji"
            >
                <!--				<svg-icon name="emoji" :param="emojiReaction ? 'reaction' : ''" />-->
                <slot>
                    <svg id="smile" xmlns="http://www.w3.org/2000/svg" width="26.212" height="26.211" viewBox="0 0 26.212 26.211">
                        <g id="Group_75" data-name="Group 75" transform="translate(0 0)">
                            <g id="Group_74" data-name="Group 74">
                                <path id="Path_142" data-name="Path 142" d="M115.207,224.145a.57.57,0,0,0-.8.044,6.339,6.339,0,0,1-9.408,0,.57.57,0,0,0-.849.76,7.479,7.479,0,0,0,11.106,0A.57.57,0,0,0,115.207,224.145Z"
                                      transform="translate(-96.592 -208.045)" fill="#adacac"/>
                                <path id="Path_143" data-name="Path 143"
                                      d="M13.106,0A13.106,13.106,0,1,0,26.211,13.106,13.121,13.121,0,0,0,13.106,0Zm0,25.072A11.966,11.966,0,1,1,25.072,13.106,11.979,11.979,0,0,1,13.106,25.072Z" transform="translate(0 0)"
                                      fill="#adacac"/>
                                <path id="Path_144" data-name="Path 144" d="M210.849,128A2.852,2.852,0,0,0,208,130.849a.57.57,0,1,0,1.14,0,1.709,1.709,0,1,1,3.419,0,.57.57,0,1,0,1.14,0A2.852,2.852,0,0,0,210.849,128Z"
                                      transform="translate(-193.185 -118.883)" fill="#adacac"/>
                                <path id="Path_145" data-name="Path 145" d="M84.559,130.849a.57.57,0,0,0,1.14,0,2.849,2.849,0,0,0-5.7,0,.57.57,0,0,0,1.14,0,1.709,1.709,0,1,1,3.419,0Z" transform="translate(-74.302 -118.883)"
                                      fill="#adacac"/>
                            </g>
                        </g>
                    </svg>
                </slot>
            </div>
            <div
                slot="emoji-picker"
                slot-scope="{ emojis, insert }"
                v-if="emojiOpened"
            >
                <transition name="slide-up" appear>
                    <div
                        class="emoji-picker"
                        :class="{ 'picker-reaction': emojiReaction }"
                        :style="{
							height: `${emojiPickerHeight}px`,
							top: positionTop ? emojiPickerHeight : `${emojiPickerTop}px`,
							right: emojiPickerRight,
							display: emojiPickerTop || !emojiReaction ? 'initial' : 'none'
						}"
                    >
                        <div class="emoji-picker__search">
                            <input type="text" v-model="search"/>
                        </div>
                        <div>
                            <div v-for="(emojiGroup, category) in emojis" :key="category">
                                <h5 v-if="category !== 'Frequently used'">{{  trans.get('pages:chat.emoji_category.'+category)  }}</h5>
                                <div class="emojis" v-if="category !== 'Frequently used'">
									<span
                                        v-for="(emoji, emojiName) in emojiGroup"
                                        :key="emojiName"
                                        @click="insert({ emoji, emojiName })"
                                        :title="emojiName"
                                    >
										{{ emoji }}
									</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </emoji-picker>
    </div>
</template>

<script>
import EmojiPicker from 'vue-emoji-picker'

import SvgIcon from './SvgIcon'

export default {
    components: {
        EmojiPicker,
        SvgIcon
    },
    props: [
        'emojiOpened',
        'emojiReaction',
        'roomFooterRef',
        'positionTop',
        'positionRight'
    ],
    data() {
        return {
            search: '',
            emojiPickerHeight: 320,
            emojiPickerTop: 0,
            emojiPickerRight: ''
        }
    },
    methods: {
        append({emoji, emojiName}) {
            this.$emit('addEmoji', {icon: emoji, name: emojiName})
        },
        openEmoji(ev) {
            this.$emit('openEmoji', true)
            this.setEmojiPickerPosition(
                ev.clientY,
                ev.view.innerWidth,
                ev.view.innerHeight
            )
        },
        setEmojiPickerPosition(clientY, innerWidth, innerHeight) {
            setTimeout(() => {
                const mobileSize = innerWidth < 500 || innerHeight < 700

                if (!this.roomFooterRef) {
                    if (mobileSize) this.emojiPickerRight = '0px'
                    return
                }

                if (mobileSize) {
                    this.emojiPickerRight = innerWidth / 2 - 120 + 'px'
                    this.emojiPickerTop = 100
                    this.emojiPickerHeight = innerHeight - 200
                } else {
                    const roomFooterTop = this.roomFooterRef.getBoundingClientRect().top
                    const pickerTopPosition =
                        roomFooterTop - clientY > this.emojiPickerHeight - 50

                    if (pickerTopPosition) this.emojiPickerTop = clientY + 10
                    else this.emojiPickerTop = clientY - this.emojiPickerHeight - 10

                    this.emojiPickerRight = this.positionTop
                        ? '-50px'
                        : this.positionRight
                            ? '60px'
                            : ''
                }
            }, 0)
        }
    }
}
</script>

<style lang="scss" scoped>
.wrapper {
    position: relative;
    display: flex;
}

.emoji-picker {
    position: absolute;
    z-index: 9999;
    bottom: 32px;
    right: 10px;
    width: 240px;
    overflow: scroll;
    padding: 16px;
    box-sizing: border-box;
    border-radius: 0.5rem;
    background: var(--chat-emoji-bg-color);
    box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.1),
    0 1px 2px -1px rgba(0, 0, 0, 0.1), 0 1px 2px 1px rgba(0, 0, 0, 0.1);
}

.picker-reaction {
    position: fixed;
    top: initial;
    right: initial;
}

.emoji-picker__search {
    display: flex;
}

.emoji-picker__search > input {
    flex: 1;
    border-radius: 10rem;
    border: var(--chat-border-style);
    padding: 5px 10px;
    outline: none;
    background: var(--chat-bg-color-input);
    color: var(--chat-color);
}

.emoji-picker h5 {
    margin: 15px 0 8px;
    color: #b1b1b1;
    text-transform: uppercase;
    font-size: 0.8rem;
    cursor: default;
}

.emoji-picker .emojis {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.emoji-picker .emojis:after {
    content: '';
    flex: auto;
}

.emoji-picker .emojis span {
    padding: 0.2rem;
    cursor: pointer;
    border-radius: 5px;
}

.emoji-picker .emojis span:hover {
    background: var(--chat-sidemenu-bg-color-hover);
    cursor: pointer;
}

.button-reaction svg {
    height: 19px;
    width: 19px;
}
</style>
